import React, { useState } from 'react';
import Button from './Button';
import { CheckIcon } from 'lucide-react';
import Wizard from './Wizard';
import { Link } from 'react-router-dom';
const plans = [{
  name: 'Performance',
  price: 'Free',
  period: 'to start',
  description: 'Start with a connected store powered by search — perfect for testing AI sales without risk.',
  features: ['Store connected via search', 'Up to 500 conversations/month', '1 AI sales agent channel', 'Basic analytics & reporting', 'Lead collection', 'Standard support', 'Community access', '$1 per successful conversation after 500', '1 month free on all plans']
}, {
  name: 'Business',
  price: '$299',
  period: '/month',
  description: 'Best for growing businesses ready to scale their AI sales efforts.',
  features: ['Store connected via direct API to your catalog', 'Up to 5,000 conversations/month', '3 AI sales agent channels', 'Advanced analytics & insights', 'Brand voice customization', 'Booking appointment feature', 'Fast checkout integration', 'Priority support', '1 month free on all plans'],
  highlighted: true
}, {
  name: 'Enterprise',
  price: 'Custom',
  period: 'pricing',
  description: 'Enterprise-grade solution for businesses with higher needs and volume.',
  features: ['Store custom-built & API connected', 'Unlimited conversations', 'Unlimited channels', 'Enterprise analytics', 'Custom integrations', 'Booking appointment feature', 'Fast checkout integration', 'Dedicated support team', 'SLA guarantees & multi-region support', '1 month free on all plans']
}];
const Pricing = () => {
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  return <section id="pricing" className="py-16 bg-white" data-id="element-2088">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2089">
        <div className="text-center mb-12" data-id="element-2090">
          <h2 className="text-3xl font-bold mb-4" data-id="element-2091">Plans & Pricing</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-2092">
            Simple, transparent pricing that scales with your business
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-2093">
          {plans.map((plan, index) => <div key={index} className={`bg-white rounded-xl p-8 shadow-card border ${plan.highlighted ? 'border-primary' : 'border-gray-100'} relative`} data-id="element-2094">
              {plan.highlighted && <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-primary text-white text-sm px-4 py-1 rounded-full" data-id="element-2095">
                  Most Popular
                </div>}
              <h3 className="text-xl font-bold mb-2" data-id="element-2096">{plan.name}</h3>
              <div className="mb-4" data-id="element-2097">
                <span className="text-3xl font-bold" data-id="element-2098">{plan.price}</span>
                <span className="text-gray-600" data-id="element-2099">{plan.period}</span>
              </div>
              <p className="text-gray-600 mb-6" data-id="element-2100">{plan.description}</p>
              <ul className="space-y-3 mb-8" data-id="element-2101">
                {plan.features.map((feature, featureIndex) => <li key={featureIndex} className="flex items-start" data-id="element-2102">
                    <CheckIcon className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" data-id="element-2103" />
                    <span className="ml-3 text-gray-600" data-id="element-2104">{feature}</span>
                  </li>)}
              </ul>
              <Button variant={plan.highlighted ? 'primary' : 'outline'} fullWidth onClick={() => setIsWizardOpen(true)} data-id="element-2105">
                {plan.name === 'Performance' ? 'Get Started Free' : plan.name === 'Enterprise' ? 'Contact Sales' : 'Start Free Trial'}
              </Button>
            </div>)}
        </div>
        <div className="mt-10 text-center" data-id="element-2106">
          <p className="text-gray-600 mb-4" data-id="element-2107">
            <span className="font-semibold" data-id="element-2108">💡 Additional usage fees:</span> All
            plans can scale with you — we charge per conversion, lead, or any
            custom function you define.
          </p>
          <Link to="/pricing" data-id="element-2109">
            <Button variant="outline" data-id="element-2110">View Full Pricing Details</Button>
          </Link>
        </div>
      </div>
      <Wizard isOpen={isWizardOpen} onClose={() => setIsWizardOpen(false)} data-id="element-2111" />
    </section>;
};
export default Pricing;